





















import { ANY_BUSINESS } from "@model/Filters";
import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";

interface TimeSeriesBusiness {
  id: number;
  name: string;
}

@Component({
  components: {},
})
export default class TimeSeriesBusinessSelect extends Vue {
  // TODO: fix. Specify types

  @Prop({ default: false, type: Boolean }) allowAny!: boolean;
  @Model("change", { default: null }) value!: TimeSeriesBusiness | number | null;

  get controlValue(): TimeSeriesBusiness | null {
    if (!this.value) {
      return this.allowAny ? ANY_BUSINESS : null;
    }

    return typeof this.value === "number"
      ? this.options.find((x) => x.id === this.value) ?? null
      : this.value;
  }

  options: any[] = [];
  isLoading = false;

  @Watch("$store.state.filters", { deep: true })
  updateData() {
    this.isLoading = this.$store.state.filters.isLoading;
    const result = [...this.$store.state.filters.businesses];

    if (this.allowAny) {
      result.unshift(ANY_BUSINESS);
    }

    this.options = result;
  }

  updateSelected(option: TimeSeriesBusiness) {
    this.$emit("change", option.id);
  }

  created() {
    this.updateData();
  }
}
